import Actions from '../../odata/actions';

const actions = new Actions('crewTopSheetDocument', 'crewTopSheetDocuments');

export default actions;
